// extracted by mini-css-extract-plugin
module.exports = {"button":"IconButton-button-tsuv1"};